import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import styles from "../styles/level1.module.css"
import level0instr from "../images/level0/level0instr.png"
import instrLink from "../images/level0/instrLink.png"
import level0Task0 from '../solutionxml/level0Task0'
import BlocklyComponent, { Block, Value, Field, Shadow } from '../Blockly';

import fulltoolbox from '../toolboxes/fulltoolbox';
import level5xml from '../solutionxml/level5xml'

const level6 = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Level 6: Graphing 
      </h1>
      <br></br>
      <div className={styles.center}>
        <h3 className={styles.instructions}> Task 0: Use the Blockly Workspace below to make a bar graph using the environmental sensor & harvest data. Use the 'Run' button to see the output!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div>
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox={fulltoolbox}
      solutionXml={level5xml}>
    </BlocklyComponent>
  </div>
  <br></br>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 1: Use the Blockly Workspace below to make a line graph using the environmental sensor & harvest data. Use the 'Run' button to see the output!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div>
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
     
      toolbox={fulltoolbox}
      solutionXml={level5xml}>
    </BlocklyComponent>
  </div>
  <br></br>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: Use the Blockly Workspace below to make a pie chart using the environmental sensor & harvest data. Use the 'Run' button to see the output!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div>
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      
      toolbox={fulltoolbox}
      solutionXml={level5xml}>
    </BlocklyComponent>
  </div>
  <br></br>
  <br></br>
  <div className={styles.center}>
        <h3 className={styles.instructions}> Task 2: Use the Blockly Workspace below to make a pie chart using the environmental sensor & harvest data. Use the 'Run' button to see the output!</h3>
      </div>
      <br></br>
      <div className={styles.right}>
        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/document/d/1EPMK56GdFUIoGVYIRQmLr1K3wPmGxoRxPQyreCBZgng/edit">
          <img src={instrLink} alt="level 0 instructions" style={{ 'justify-content': 'center' }} width={600} height={150}/>
        </a>
      </div>
    <div>
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}>
    </BlocklyComponent>
  </div>
  </main>
  </div>
  );
}
  
export default level6;